<p-colorPicker [formControl]="formControl" [formlyAttributes]="field"></p-colorPicker>